<div class="page pb-0">
  <div class="container-fluid p-0">
    <div class="breadcrumb-generic breadcrumb-generic--overlay" style="background-image: url('./assets/images/bg_cookies.jpg');">
      <div class="container-sm">
        <h1 class="breadcrumb-generic__title">Privacy Policy</h1>
      </div>
    </div>
  </div>
  <div class="page-content generic-page">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="e-title e-title__with-divider">
            <h2 class="h2">Privacy Policy</h2>
            <hr class="hr hr--heavy hr--brand hr--title mb-2">
          </div>
        </div>
      </div>
      <div class="row" [class.mt-3]="isWtgNetworkSite">
        <div class="col offset-lg-1" [innerHTML]="privacy$ | async">
        </div>
      </div>
    </div>
  </div>
</div>
